<template>
  <div v-for="(item, index) in urlAnalysis" :key="index">
    <div class="tw-mb-4">
      <cl-badge :variant="'warning'">
        <span class="tw-text-base tw-font-normal">{{ item.status }}</span>
      </cl-badge>
    </div>
    <div class="tw-mb-4">
      <cl-p>{{ item.message }}</cl-p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IncidentDetailsAnalysis } from "@/modules/PhishTitan/types/IncidentSummary";

defineProps<{ urlAnalysis: IncidentDetailsAnalysis[] }>();
</script>
